import Checkbox from "../../../../../../packages/design-system/src/Checkbox";
import * as React from 'react';
export default {
  Checkbox,
  React
};